export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-interface-d7ac80c3b1fbaec687de69c82b942413.png";